import '../css/index.scss';
import 'bootstrap/dist/js/bootstrap.bundle'
import './components';
import {lazyloadImagesWhenReadyAndSetupListeners} from "./lazyloading";
import onInit from "./utils/onInit";

onInit(() => {
  lazyloadImagesWhenReadyAndSetupListeners();

  jQuery('body').on('added_to_cart', function () {
    console.log("added!!!")
    // Callback -> product added
    //$('.popup').show();
  });
})

console.log("welcome");
